import React from "react";
import Modal from "react-bootstrap/Modal"
import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {login, showLogin} from "../user/UserActions";
import LoginForm from "./LoginForm";
import {LoginStatus} from "../http/Types";
import {LoginError} from "../user/UserReducer";
import {Link} from "react-router-dom";

interface Props {
    show?: boolean,
    hide ? : ()=>void;
    login? : (email : string, password : string) => void;
    status?: LoginStatus;
    loginError?: LoginError;
};


export const LoginModal = (props : Props) => (
    <Modal size="sm"
           aria-labelledby="contained-modal-title-vcenter"
           centered
           show={props.show}
           onHide={()=> props.hide && props.hide()}
        >
        <Modal.Header closeButton>
            <Modal.Title>Login to Nano</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <LoginForm  />
          <div className={"divider"}></div>
            <Link to={"/register"} onClick={()=>props.hide && props.hide()} className={"btn btn-block btn-secondary"}>Create New Account</Link>
        </Modal.Body>
    </Modal>
);
const mapStateToProps = (state : AppState) : Props => (
    {
        show : state.user.displayLogin,
        status: state.user.status,
        loginError: state.user.loginError
    }
)
const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        hide : () => dispatch(showLogin(false)),
        login : (email: string, password : string) => dispatch(login({email : email , password : password}) as any)
    }
)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginModal)